import { render } from "./ColorPickerDialog.vue?vue&type=template&id=527abcae&scoped=true"
import script from "./ColorPickerDialog.vue?vue&type=script&lang=js"
export * from "./ColorPickerDialog.vue?vue&type=script&lang=js"

import "./ColorPickerDialog.vue?vue&type=style&index=0&id=527abcae&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527abcae"]])

export default __exports__